<template>
    <li :title="text" class="nav-item">
        <Link
            :class="{
                'c-active': isActive,
            }"
            :href="url"
            class="nav-link justify-between"
        >
            <div class="flex items-center">
                <slot name="icon">
                    <icon :name="icon" class="nav-icon" />
                </slot>
                {{ text }}
            </div>
            <div class="flex gap-1">
                <span
                    v-if="count !== undefined"
                    :class="isActive ? 'bg-[#F0F3FB] text-[#2563eb]' : 'bg-[#3F4B68] text-white'"
                    class="h-5 rounded-full bg-[#3F4B68] px-2 text-xs leading-5"
                    >{{ count }}</span
                >
            </div>
        </Link>
        <slot />
    </li>
</template>
<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n.js';
import Icon from '@/Components/Icon.vue';

const props = defineProps({
    routeName: String,
    icon: String,
    href: String,
    title: String,
    count: Number,
});

const page = usePage();
const url = computed(() => props.href || route(props.routeName));
const text = computed(() => props.title || trans('navigation.' + props.routeName));
const isActive = computed(() => page.props.activeNavigation[props.routeName] || false);
</script>
